import { isItemGoingToInventory } from './cart.utils';
export const isRenderAsInventoryItems = (isBox, item) => !isBox && isItemGoingToInventory(item);